"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const HelpfulButtons = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
`;
function ThumbFeedback({ onClick, iconSize = 39, disabled, buttonProps, }) {
    const [clicked, setClicked] = (0, react_1.useState)();
    const submitHelpful = (helpful) => () => {
        const value = helpful === clicked ? undefined : helpful;
        setClicked(value);
        onClick(value);
    };
    return ((0, jsx_runtime_1.jsxs)(HelpfulButtons, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "true-helpful", disabled: disabled, onClick: submitHelpful(true), ...buttonProps, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.LikeIcon, { clicked: clicked === true, size: iconSize }) }), (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "false-helpful", disabled: disabled, onClick: submitHelpful(false), ...buttonProps, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.DislikeIcon, { clicked: clicked === false, size: iconSize }) })] }));
}
exports.default = ThumbFeedback;
//# sourceMappingURL=index.js.map